// **********************************************************************
//
// AudioTrack
//
// A HTML Audio Element Track
//
// **********************************************************************

import MediaElementTrack from './MediaElementTrack'

const defaultAttr = {
  preload: 'auto',
  crossorigin: 'anonymous'
}

class AudioTrack extends MediaElementTrack {
  constructor(trackConfig) {
    super(trackConfig, 'audio', defaultAttr)
  }
}

export default AudioTrack
